import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import dashboardColors from '~/helpers/dashboardColors';
import { Button as ButtonElement } from '~/elements';
import { Loader } from '~/components';
import { cards, common } from '~/helpers/api';
import messages from '~/helpers/api/messages';
import { ToastCtx } from '~/providers/ToastProvider';
import ValidateCard from './ValidateCard';
import { VRPAT } from '~/config/constants';

const Button = styled(ButtonElement)`
  margin-top: 40px !important;
`;
const Container = styled.form`
  display: flex;
  align-items: center;
  background-color: ${({ theme, activeCardCode }) =>
    dashboardColors(theme, activeCardCode).bgModal};
  color: ${({ theme, activeCardCode }) =>
    dashboardColors(theme, activeCardCode).colorModal};
  padding: 15px 0;

  @media (min-width: ${({ theme }) => theme.devices.mobile}) {
    padding: 0;
  }
`;

const Content = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 15px;

  button {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.devices.mobile}) {
    padding: 70px 0;
  }
`;

export default function UnlockCard({ setStep, updateCards }) {
  const { handleSubmit, errors, formState, ...formControl } = useForm({
    mode: 'onChange',
  });
  const toast = useContext(ToastCtx);
  const [isLoading, setIsloading] = useState(false);
  const user = useSelector(state => state.user);
  const activeCard = useSelector(state => state.home.cards.active);
  const [reCaptchaKey, setReCaptchaKey] = useState('');
  const [successReCaptcha, setSuccessReCaptcha] = useState('');
  const issuer = useSelector(state => state?.issuer?.name);
  const color = issuer === VRPAT ? 'secondary' : 'caixa';

  async function getReCaptchaKey() {
    try {
      const response = await common.getReCaptchaKey();
      const { result } = response;

      setReCaptchaKey(result?.secretKey);
    } catch (e) {
      toast.dispatch(messages(e, 'recaptcha'));
    }
  }

  useEffect(() => {
    if (!reCaptchaKey) {
      getReCaptchaKey();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function onSubmit(formPayload) {
    const { cardNumber } = formPayload;
    const { birthdate, cpf } = user;

    const payload = {
      birthDate: birthdate,
      cpf,
      numberCard: cardNumber.replace(/\s/g, ''),
    };

    try {
      setIsloading(true);
      const response = await cards.unlockCard(payload);
      await updateCards();
      toast.dispatch(messages(response, 'unlock_card'), 'success');
    } catch (error) {
      toast.dispatch(
        messages(error, 'unlock_card', <span>{error?.result}</span>),
      );
    } finally {
      setStep('');
      setIsloading(false);
    }
  }

  return (
    <Container activeCardCode={activeCard?.codigoProduto}>
      <Loader isLoading={isLoading}>
        <Content onSubmit={handleSubmit(onSubmit)}>
          <ValidateCard
            formControl={formControl}
            errors={errors}
            codigoProduto={activeCard?.codigoProduto}
            successReCaptcha={successKey => setSuccessReCaptcha(successKey)}
            reCaptchaKey={reCaptchaKey}
            issuer={issuer}
          />
          <Button
            disabled={!formState.isValid || !successReCaptcha}
            label="Desbloquear"
            color={color}
            type="submit"
          />
        </Content>
      </Loader>
    </Container>
  );
}

UnlockCard.propTypes = {
  setStep: PropTypes.func,
  updateCards: PropTypes.func,
};
